import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useClientAuth } from "./ClientAuthProvider";
import { Splash } from "@/components/chrome/Splash";
import { NoAccount } from "@/screens/NoAccount";

/**
 * Wraps every signed-in route. Loading → branded splash. No session → /login
 * (remembering where they were going). Session but no client record → the
 * "ask your strategist" screen with a sign-out. Otherwise render the app.
 */
export function AuthGate() {
  const { access } = useClientAuth();
  const location = useLocation();

  if (access.state === "loading") return <Splash />;
  if (access.state === "unauthenticated") {
    const next = `${location.pathname}${location.search}`;
    const suffix = next && next !== "/" ? `?next=${encodeURIComponent(next)}` : "";
    return <Navigate to={`/login${suffix}`} replace />;
  }
  if (access.state === "no_client") return <NoAccount message={access.message} email={access.user.email ?? null} />;
  return <Outlet />;
}
